import { TranslationLabels } from "translations/TranslationLabels";

/**
 * User status enumeration.
 * Corresponds to C# UserStatusEnum.
 */
export enum UserStatusEnum {
  Unknown = 0,
  Deleted = 1,
  Enabled = 2,
}

/**
 * Gets the localized label for a UserStatusEnum value.
 */
export function getUserStatusLabel(value: UserStatusEnum, i18n: TranslationLabels): string {
  switch (value) {
    case UserStatusEnum.Unknown:
      return i18n.UserStatus_Unknown;
    case UserStatusEnum.Deleted:
      return i18n.UserStatus_Deleted;
    case UserStatusEnum.Enabled:
      return i18n.UserStatus_Enabled;
    default:
      return `Unknown UserStatusEnum: ${value}`;
  }
}
